import { computed, defineComponent } from 'vue';
import { PlaceholderType } from '@getaccept/editor-lib-new/src/types/enums';
import EditorNodeWrapper from '../EditorNodeWrapper.vue';
import ResourcePlaceholder from './ResourcePlaceholder.vue';
import ElementPlaceholder from './ElementPlaceholder.vue';
export default defineComponent({
    components: {
        EditorNodeWrapper,
        ResourcePlaceholder,
        ElementPlaceholder,
    },
    props: {
        node: {
            type: Object,
            required: true,
        },
        parentFirstChild: { type: Boolean },
        parentLastChild: { type: Boolean },
        blockWidthClass: { type: String, default: null },
        rowTypeClass: { type: String, default: null },
        placeholder: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const isResourcePlaceholder = computed(() => { var _a, _b; return ((_b = (_a = props.node) === null || _a === void 0 ? void 0 : _a.placeholder) === null || _b === void 0 ? void 0 : _b.type) === PlaceholderType.Resource; });
        return {
            isResourcePlaceholder,
        };
    },
});
